import { useMemo } from 'react';
import { faCircleArrowDown } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { ReportType } from '@customTypes/order';
import { stringToHTML } from '@helpers/string';
import { OrderType } from '@pages/results/Results.types';

import { getNextStepsResources } from './NextStepsPane.utils';

interface IProps {
  nextSteps: string[];
  orderType: OrderType;
  productName: string;
  reportType?: ReportType;
}

const NextStepsPane = ({ orderType, nextSteps, productName, reportType }: IProps) => {
  const steps = useMemo(() => (nextSteps?.length > 0 ? nextSteps : []), [nextSteps]);
  const { title, samples } = useMemo(
    () => getNextStepsResources(orderType, productName, reportType),
    [orderType, productName, reportType],
  );

  return (
    <div className='next-steps-pane result-details-tab-content'>
      {steps.length > 0 && (
        <div className='next-steps'>
          <p className='section-title'>Next Steps</p>
          <ul>
            {steps.map((step, index) => (
              <li key={index} dangerouslySetInnerHTML={{ __html: stringToHTML(step) }} />
            ))}
          </ul>
        </div>
      )}

      {samples.length > 0 && (
        <div className='learn-more'>
          <p className='section-title px-3'>{title}</p>
          <ul>
            {samples.map((sample, index) => (
              <li key={index}>
                <FontAwesomeIcon icon={faCircleArrowDown} color='#003595' fontSize={16} className='me-2' />
                <a href={sample.url} target='_blank' rel='noopener noreferrer'>
                  {sample.title}
                </a>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default NextStepsPane;
